"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const icons_1 = require("@material-ui/icons");
const pickers_1 = require("@material-ui/pickers");
const moment = require("moment");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const HelperText_1 = require("./HelperText");
const DateFieldValidator = (_a) => {
    var _b, _c, _d, _e, _f, _g;
    var { t, validationSchema, onOpen, isTouched, value, inputVariant = 'filled', keyboardVariant = false } = _a, rest = __rest(_a, ["t", "validationSchema", "onOpen", "isTouched", "value", "inputVariant", "keyboardVariant"]);
    const classes = useStyles();
    const theme = (0, core_1.useTheme)();
    const isMobile = (0, core_1.useMediaQuery)(theme.breakpoints.down('sm'));
    const [touched, setTouched] = React.useState(isTouched);
    const hasError = () => {
        if (!touched) {
            return false;
        }
        return validationSchema ? !validationSchema.isValidSync(value) : false;
    };
    const modalOpen = () => {
        if (onOpen) {
            onOpen();
        }
        setTouched(true);
    };
    const handleFocus = () => setTouched(true);
    const renderFullDateDay = (day, selectedDate, isInCurrentMonth, dayComponent) => {
        if (!day)
            return dayComponent;
        const fullDateLabel = moment(day).format('MMMM Do, YYYY');
        const isSelected = selectedDate && moment(day).isSame(selectedDate, 'day');
        const ariaLabel = isSelected ? `${fullDateLabel} (selected)` : fullDateLabel;
        return React.cloneElement(dayComponent, {
            'aria-label': ariaLabel
        });
    };
    const arrowButtonProps = {
        leftArrowButtonProps: { 'aria-label': t('previousMonth', 'Previous month') },
        rightArrowButtonProps: { 'aria-label': t('nextMonth', 'Next month') }
    };
    const isError = hasError() || !!rest.error;
    const errorText = (_b = rest.helperText) !== null && _b !== void 0 ? _b : t('field.error', 'Please enter a valid ' + ((_c = rest.label) !== null && _c !== void 0 ? _c : (_d = rest.inputProps) === null || _d === void 0 ? void 0 : _d['aria-label']), {
        fieldLabel: (_e = rest.label) !== null && _e !== void 0 ? _e : (_f = rest.inputProps) === null || _f === void 0 ? void 0 : _f['aria-label']
    });
    const helperText = isError ? errorText : ((_g = rest.helperText) !== null && _g !== void 0 ? _g : '');
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: keyboardVariant === false ? ((0, jsx_runtime_1.jsx)(pickers_1.DatePicker, Object.assign({}, arrowButtonProps, { renderDay: renderFullDateDay, value: value }, rest, { format: "MM/DD/YYYY", onOpen: modalOpen, onFocus: handleFocus, error: hasError() || rest.error, DialogProps: {
                className: 'po-widget-datepicker'
            }, inputVariant: inputVariant, FormHelperTextProps: { className: classes.helperText }, helperText: (0, jsx_runtime_1.jsx)(HelperText_1.default, { id: `${rest.id}-helper-text`, helperText: helperText, isError: isError }) }, (rest.hiddenLabel ? { label: '' } : {}), { inputProps: Object.assign(Object.assign({}, rest.inputProps), { id: rest.id, 'aria-labelledby': `${rest.id}-label`, 'aria-describedby': `${rest.id}-helper-text` }) }))) : ((0, jsx_runtime_1.jsx)(pickers_1.KeyboardDatePicker, Object.assign({}, arrowButtonProps, { renderDay: renderFullDateDay, value: value, KeyboardButtonProps: {
                'aria-label': `Change ${rest.id}`
            }, keyboardIcon: (0, jsx_runtime_1.jsx)(icons_1.CalendarToday, {}) }, rest, { format: "MM/DD/YYYY", onOpen: modalOpen, onFocus: handleFocus, error: hasError() || rest.error, DialogProps: {
                className: 'po-widget-datepicker'
            }, inputVariant: inputVariant, FormHelperTextProps: { className: classes.helperText }, helperText: (0, jsx_runtime_1.jsx)(HelperText_1.default, { id: `${rest.id}-helper-text`, helperText: helperText, isError: isError }) }, (rest.hiddenLabel ? { label: '' } : {}), { inputProps: Object.assign(Object.assign({}, rest.inputProps), { id: rest.id, 'aria-labelledby': `${rest.id}-label`, 'aria-describedby': `${rest.id}-helper-text`, className: isMobile ? classes.customInput : '' }) }))) }));
};
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    helperText: {
        display: 'flex',
        gap: theme.spacing(1),
        marginLeft: 0,
        marginRight: 0,
        marginTop: theme.spacing(0.5),
        alignItems: 'center'
    },
    customInput: {
        fontSize: '12px'
    }
}));
exports.default = (0, react_i18next_1.withTranslation)()(DateFieldValidator);
//# sourceMappingURL=DateFieldValidator.js.map